import {Timeline} from "gsap";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {TombOfAkhenaten} from "../../TombOfAkhenaten";
import {TombOfAkhenatenReelController} from "../../reel/TombOfAkhenatenReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {TombOfAkhenatenGameConfig} from "../../TombOfAkhenatenGameConfig";
import {SpinStart} from "../spin/SpinStart";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";

export class ReelStop implements GameRoundPresentation {
    stagger?:number;
    abortStagger?:number;

    private readonly _reelId:number;
    private readonly _stopDelay:number;
    private readonly _quickStopDelay:number;

    constructor(reelId:number, stagger?:number, abortStagger?:number) {
        this._reelId = reelId;
        this._stopDelay = TombOfAkhenaten.timelineReelsController.getReelConfig(this._reelId).stopDelay;
        this._quickStopDelay = TombOfAkhenaten.timelineReelsController.getReelConfig(this._reelId).quickStopDelay;

        //Override config
        if(stagger !== undefined) {
            this._stopDelay = stagger;
        }
        if(abortStagger !== undefined) {
            this._quickStopDelay = abortStagger;
        }

        this.stagger = this._stopDelay;
        this.abortStagger = this._quickStopDelay;
    }

    public getAnimation(data:ParsedGameData):Timeline | null {
        this.stagger = GameSetting.isFastSpin ? this._quickStopDelay : this._stopDelay;
        return this.stopReel(data, false);
    }

    public abort(isActive:boolean, data:ParsedGameData):Timeline | null {
        return this.stopReel(data, true);
    }

    private stopReel(data:ParsedGameData, isQuickStop:boolean):Timeline | null {
        if(SpinStart.isFullStickyReel){//condition if all symbols are sticky reel doesn't need to spin and stop but have to complete cycle
            EventHandler.dispatchEvent(new GameEvent(ReelEvent.REEL_STOP_PRESENTATIONS_COMPLETE, this._reelId));
            return null;
        }
        // #17 symName cannot be null
        (<TombOfAkhenatenReelController>Reels.getReel(this._reelId)).updateGameData(data);
        let retVal = TombOfAkhenaten.timelineReelsController.stopSpin(this._reelId, data, isQuickStop);

        retVal.eventCallback("onComplete", () => {
            (Reels.getReel(this._reelId)! as TombOfAkhenatenReelController).animateSymHeight(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN);
        });

        return retVal;
    }
}